export const hex2rgba = (hexStr, alpha) => {
  let hex = hexStr.replace('#', '')
  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)
  return [r, g, b, alpha]
}

export const loadChainedScripts = (paths, clb) => {
  let fn = (p, i) => {
    console.log('loading '+p[i])
    let head = document.getElementsByTagName("head")[0];
    let js = document.createElement("script");
    js.type = "text/javascript";
    js.src = p[i];
    js.addEventListener('load', () => {
      if (paths[i+1]) {
        fn(p, i+1)
      } else {
        clb && clb()
      }
    }, false)
    head.appendChild(js);
  }
  fn(paths, 0)

}


export const fixZcoord = (coordinates) => {

  if (typeof coordinates !== 'object') {
    return coordinates
  }

  let f = (cc) => {

    if (typeof cc[0] === 'object') {
      cc.forEach(c1 => f(c1))
    } else {
      if (cc.length === 3) {
        cc.splice(2, 1)
      }
    }
  }

  f(coordinates)

  return coordinates

}


export const debounce = function (func, timeout) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
};



// WEBPACK FOOTER //
// ./src/util/misc.js